import { HttpContextToken, HttpErrorResponse, HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { tap } from "rxjs";
import { NotificationMessageService } from "../../services/notification.message.service";
import { ObservableService } from "../../services/observable.service";
import { ServerFormErrorService } from "../../services/server-form-error.service";

export const skipValidationErrorToast = new HttpContextToken<boolean>(() => false);

export const validationErrorInterceptor: HttpInterceptorFn = (request, next) => {
  const observableService = inject(ObservableService);
  const serverFormErrorService = inject(ServerFormErrorService);
  const messages = inject(NotificationMessageService);

  return next(request).pipe(
    tap({
      error: (error: HttpErrorResponse) => {
        if (error.status !== 400) {
          return;
        }
        const errorResponse = error.error;
        const validationErrors = errorResponse?.validation_errors ?? {};
        const nonFieldErrors = validationErrors?.non_field_errors;
        const message =
          (Array.isArray(nonFieldErrors) && nonFieldErrors[0]) || errorResponse?.message;

        if (Object.keys(validationErrors).length) {
          observableService.setValidationErrors(validationErrors);
          serverFormErrorService.setServerError(validationErrors);
        }

        if (!request.context.get(skipValidationErrorToast) && message) {
          messages.showErrorMessage(message);
        }
      },
    }),
  );
};
